import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "22 22 44 44",
	...props,
	children: /* @__PURE__ */ _jsxs("circle", {
		cx: 44,
		cy: 44,
		r: 20.2,
		stroke: "currentColor",
		strokeWidth: 3.6,
		fill: "none",
		strokeDasharray: "80, 200",
		strokeDashoffset: 0,
		children: [/* @__PURE__ */ _jsx("animate", {
			attributeName: "stroke-dasharray",
			values: "1, 200; 100, 200; 1, 200",
			keyTimes: "0; 0.5; 1",
			keySplines: "0.42 0 0.58 1; 0.42 0 0.58 1",
			calcMode: "spline",
			dur: "1.4s",
			repeatCount: "indefinite"
		}), /* @__PURE__ */ _jsx("animate", {
			attributeName: "stroke-dashoffset",
			values: "0; -15; -126",
			keyTimes: "0; 0.5; 1",
			keySplines: "0.42 0 0.58 1; 0.42 0 0.58 1",
			calcMode: "spline",
			dur: "1.4s",
			repeatCount: "indefinite"
		})]
	})
});
export default SvgSpinner;
